module.exports = __webpack_public_path__ + "static/media/bg1.e0209e39.webp";